const toggleSearchWithBackdrop = () => {
  document.querySelector('.wm-backdrop').classList.toggle('active');
  document.querySelector('.nav-search').classList.toggle('d-none');
  document.querySelector('body').classList.toggle('modal-open');
}
document.addEventListener('DOMContentLoaded', () => {
  const searchBtnEl = document.getElementById('search-btn');
  const searchBtnMobileEl = document.getElementById('search-btn-mobile');
  const searchInputEl = document.getElementById('search-input');

  const els = [
    searchBtnMobileEl,
    searchBtnEl
  ]

  Array.prototype.forEach.call(els, (el) => {
    el.addEventListener('click', (e) => {
      toggleSearchWithBackdrop();
      searchInputEl.focus();
    });
  });

  document.getElementById('nav-search-form').addEventListener('submit', (e) => {
    e.preventDefault();
    fetchSearchResults(searchInputEl.value);
  });
});

const fetchSearchResults = (searchStr) => {
  const searchResultsEl = document.querySelector('.nav-search-results');
  searchResultsEl.classList.remove('d-none');
  searchResultsEl.innerHTML = renderLoadingPlaceholder();
  fetch(`/wp-json/wolfmma-blocks/v1/search?s=${searchStr}`)
      .then((res) => res.json())
      .then((res) => {
        renderSearchResults(res);
      }).catch(() => {
    alert('Something went wrong while searching, please try again later.')
  });
}

const renderSearchResults = (data) => {
  const searchResultsEl = document.querySelector('.nav-search-results');
  let newHtml = "";

  (data || []).map((item) => {
    newHtml += `
      <a href="${item.link}">
        <span class="nav-search-results-type">${translateTypeName(item.type)}</span>
        <div class="d-flex nav-search-results-row">
          ${renderImageOrIcon(item)}
          <p class="nav-search-results-name">${item.title}</p>
        </div>
      </a>
    `;
  });

  searchResultsEl.innerHTML = newHtml;
}

const renderLoadingPlaceholder = () => {
  return `
  <div><h5 class="card-title placeholder-glow"><span class="placeholder" style="width: 56px;"></span></h5><h5 class="card-title placeholder-glow"><span class="placeholder" style="width: 220px;"></span></h5></div>
  `;
}

const translateTypeName = (type) => {
  switch (type) {
    case "qwb_affiliation":
      return "Affiliation";
    case "qwb_theme_fighter":
      return "Fighter";
    case "qwb_theme_event":
      return "Event";
    default:
      return "Page";
  }
}

const renderImageOrIcon = (item) => {
  switch (item.type) {
    case "qwb_affiliation":
      if (item.thumbnail_url) {
        return `
        <img class="nav-search-results-img" src="${item.thumbnail_url}" alt="${item.title}"/>
      `;
      } else {
        return `
      <div class="nav-search-results-noimg">
        <i class="bi bi-buildings-fill" style="font-size: 32px;"></i>
      </div>
      `;
      }
    case "qwb_theme_fighter":
      if (item.thumbnail_url) {
        return `
        <img class="nav-search-results-img" src="${item.thumbnail_url}" alt="${item.title}"/>
      `;
      } else {
        return `
      <div class="nav-search-results-noimg">
        <i class="bi bi-person-fill"></i>
      </div>
      `;
      }
    case "qwb_theme_event":
    case "page":
    default:
      return "";
  }
}
